import { ComponentRef, Directive, Injector, Input, OnChanges, OnInit, ViewContainerRef, inject } from '@angular/core';

import { FORM_COMPONENT_TOKEN, IFormComponent } from '@shared/components/forms/components/field-base/form-component.interface';
import { FormsService } from '@shared/components/forms/services';
import { Field, IFieldConfig } from '@shared/models';
import { FormListService } from './form-list.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[libdFormField]',
})
export class FormFieldDirective implements Field, OnChanges, OnInit {
  private readonly container = inject(ViewContainerRef);
  private readonly formComponent = inject<IFormComponent>(FORM_COMPONENT_TOKEN);
  private readonly formsService = inject(FormsService);

  private readonly components = inject(FormListService).getComponents();
  // TODO: Skipped for migration because:
  //  This input overrides a field from a superclass, while the superclass field
  //  is not migrated.
  @Input() public config: IFieldConfig | undefined;
  public component: ComponentRef<Field> | undefined;

  public ngOnChanges() {
    if (this.component) {
      this.component.instance.config = this.config;
    }
  }

  public ngOnInit() {
    if (!this.config) {
      throw new Error('Config is undefined');
    }

    if (!this.components[this.config.type]) {
      const supportedTypes = Object.keys(this.components).join(', ');
      throw new Error(`Trying to use an unsupported type (${this.config.type}). Supported types: ${supportedTypes}`);
    }

    // Create a custom injector that provides the required dependencies
    const customInjector = Injector.create({
      providers: [
        { provide: FORM_COMPONENT_TOKEN, useValue: this.formComponent },
        { provide: FormsService, useValue: this.formsService },
      ],
      parent: this.container.injector,
    });

    this.component = this.container.createComponent(this.components[this.config.type], {
      injector: customInjector,
    });
    this.component.instance.config = this.config;
  }
}
